import { render, staticRenderFns } from "./NumberOfInjuryPart.vue?vue&type=template&id=0ba750cc&scoped=true&"
import script from "./NumberOfInjuryPart.vue?vue&type=script&lang=js&"
export * from "./NumberOfInjuryPart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ba750cc",
  null
  
)

export default component.exports